import AdminListingActions from "../../components/admin/AdminListingActions";
import AdminListToolbar from "../../components/admin/AdminListToolbar";
import AdminPagination from "../../components/admin/AdminPagination";
import { listingCoverImage } from "../../lib/fileUrl";

export default function AdminAllListingsTab({
  allListings,
  allListingsSearchDraft,
  onAllListingsSearchDraftChange,
  onAllListingsSearch,
  allListingsTotal,
  allListingsPage,
  allListingsTotalPages,
  onPageChange,
  onPause,
  onResume,
  onDelete,
}) {
  return (
    <div className="zc-card overflow-hidden overflow-x-auto zc-stack-table mt-4" data-testid="admin-all-listings">
      <AdminListToolbar
        draft={allListingsSearchDraft}
        onDraftChange={onAllListingsSearchDraftChange}
        onSearch={onAllListingsSearch}
        placeholder="Search listings by title, host, city, plate…"
        testid="admin-all-listings-search"
        total={allListingsTotal}
        shown={allListings.length}
      />
      <div className="hidden md:grid md:grid-cols-[80px,minmax(0,1.5fr),minmax(0,1fr),minmax(5.5rem,auto),minmax(6.5rem,auto)] gap-4 zc-stack-head px-4 sm:px-6 py-3 text-xs uppercase tracking-widest text-[var(--zc-text-3)] border-b border-[var(--zc-border)] font-semibold min-w-[720px]">
        <div className="shrink-0">Cover</div>
        <div className="min-w-0">Listing</div>
        <div className="min-w-0 truncate">Host email</div>
        <div className="shrink-0 whitespace-nowrap">Status</div>
        <div className="shrink-0 whitespace-nowrap">Actions</div>
      </div>
      {allListings.length === 0 && <div className="px-4 sm:px-6 py-10 text-center text-[var(--zc-text-3)] text-sm">No listings on file.</div>}
      {allListings.map((item) => (
        <div key={`${item.type}-${item.listing_id}`} className="zc-stack-row md:grid md:grid-cols-[80px,minmax(0,1.5fr),minmax(0,1fr),minmax(5.5rem,auto),minmax(6.5rem,auto)] md:items-center gap-4 px-4 sm:px-6 py-4 border-b border-[var(--zc-border)] last:border-0 min-w-[720px]">
          <div data-label="Cover">
            {item.image ? <img src={listingCoverImage([item.image])} className="w-20 h-14 object-cover rounded" alt="" /> : <div className="w-20 h-14 bg-[var(--zc-bg-3)] rounded" />}
          </div>
          <div data-label="Listing" className="min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <div className="zc-title text-lg">{item.title}</div>
              <span className="text-2xs uppercase tracking-widest font-semibold px-2 py-0.5 rounded border border-[var(--zc-border)] text-[var(--zc-text-3)]">{item.type}</span>
            </div>
            <div className="text-xs text-[var(--zc-text-3)]">{item.subtitle} · {item.rate_label} · {item.host_name}</div>
            <div className="text-2xs font-mono text-[var(--zc-text-2)] mt-1 break-all">{item.listing_id}</div>
          </div>
          <div data-label="Host email" className="text-xs text-[var(--zc-text-2)] break-all">{item.host_email || "—"}</div>
          <div data-label="Status">
            <span className="text-2xs uppercase tracking-widest font-semibold px-2 py-0.5 rounded border border-[var(--zc-border)] text-[var(--zc-text-3)]">{item.status}</span>
          </div>
          <div data-label="Actions">
            <AdminListingActions
              item={item}
              onPause={onPause}
              onResume={onResume}
              onDelete={onDelete}
              compact
            />
          </div>
        </div>
      ))}
      <AdminPagination
        page={allListingsPage}
        totalPages={allListingsTotalPages}
        onPageChange={onPageChange}
        testid="admin-all-listings-pagination"
      />
    </div>
  );
}
